/**
 * WordPress dependencies
 */
import { forwardRef, useRef } from '@wordpress/element';

/**
 * Internal dependencies
 */
import { ControlWithError } from '../control-with-error';
import { FormTokenField } from '../../form-token-field';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const UnforwardedValidatedFormTokenField = ({
  required,
  customValidity,
  markWhenOptional,
  ...restProps
}, forwardedRef) => {
  const validityTargetRef = useRef(null);
  return /*#__PURE__*/_jsxs("div", {
    className: "components-validated-control__wrapper-with-error-delegate",
    ref: forwardedRef,
    children: [/*#__PURE__*/_jsx(ControlWithError, {
      required: required,
      markWhenOptional: markWhenOptional,
      customValidity: customValidity,
      getValidityTarget: () => validityTargetRef.current,
      children: /*#__PURE__*/_jsx(FormTokenField, {
        ...restProps
      })
    }), /*#__PURE__*/_jsx("input", {
      className: "components-validated-control__error-delegate",
      type: "text",
      ref: validityTargetRef,
      required: required,
      value: restProps.value && restProps.value.length > 0 ? 'hasvalue' : '',
      tabIndex: -1,
      onChange: () => {},
      onFocus: e => {
        e.target.previousElementSibling?.querySelector('input[type="text"]')?.focus();
      }
    })]
  });
};
export const ValidatedFormTokenField = forwardRef(UnforwardedValidatedFormTokenField);
ValidatedFormTokenField.displayName = 'ValidatedFormTokenField';